import React, { useState, useEffect } from 'react'
import {
	Card,
	CardHeader,
	CardContent,
	Collapse,
	IconButton,
	makeStyles,
	Checkbox,
	TextField,
	ListItemText,
	Typography
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import useConstants from '../../../hooks/useConstants'
import { ExpandMoreOutlined } from '@material-ui/icons'
import { DeletableChip } from '../../Misc/DeletableChip'
import { cloneDeep } from 'lodash'
import clsx from 'clsx'
import debouncedInput from '../../../services/debouncedInput'
import StyledChip from '../../Common/StyledChip'
import { gray } from '../../../utils/colors'

const DebouncedTextField = debouncedInput(TextField, { timeout: 200 })

const useStyles = makeStyles((theme) => ({
	header: {
		padding: '13px 24px',
		userSelect: 'none',
		cursor: 'pointer',
		'& .MuiCardHeader-action': {
			margin: 0
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			marginBottom: 0
		}
	},
	fieldWrapper: {
		'& .MuiTextField-root': {
			minWidth: '424px !important'
		},
		marginBottom: '23px'
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: gray[700]
		}
	}
}))

const PetTrainingCard = (props) => {
	const classes = useStyles()

	let { pet, setPet } = props

	const [isExpanded, setIsExpanded] = useState(false)
	const { tags } = useConstants()
	const [petTrainingTags, setPetTrainingTags] = useState([])

	useEffect(() => {
		if (tags && pet.tags && pet.tags.training && pet.tags.training.length) {
			const trainingTags = tags.training.filter((tag) => {
				return pet.tags.training.findIndex((pt) => pt._id === tag._id) !== -1
			})

			setPetTrainingTags(trainingTags)
		} else {
			setPetTrainingTags([])
		}
	}, [tags, pet])

	const updatePet = (field, value) => {
		setPet({ ...pet, [field]: value })
	}

	const updateTrainingTags = (value) => {
		let updatedTags = cloneDeep(pet.tags)

		updatedTags['training'] = value

		updatePet('tags', updatedTags)
	}

	const removeTag = (value) => {
		let updatedTags = cloneDeep(pet.tags)
		let tagIndex = updatedTags['training'].findIndex((t) => t._id === value._id)

		if (tagIndex !== -1) {
			updatedTags['training'].splice(tagIndex, 1)
		}
		console.log(updatedTags)

		updatePet('tags', updatedTags)
	}

	return (
		<Card>
			<CardHeader
				className={classes.header}
				title="Training"
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, { [classes.expandOpen]: isExpanded })}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: gray[700] }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>
					<div className={classes.fieldWrapper}>
						<Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8 }}>
							Completed Classes
						</Typography>
						{pet.completed_training_courses && pet.completed_training_courses.length
							? pet.completed_training_courses.map(({ name }) => (
									<StyledChip useThemeProvider label={name} />
							  ))
							: 'No classes completed yet.'}
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<Autocomplete
							multiple
							disableCloseOnSelect
							getOptionLabel={(option) => option.name || ''}
							size="small"
							id="training-tags"
							className={classes.autoComplete}
							options={tags && tags.training ? tags.training : []}
							value={petTrainingTags}
							onChange={(e, v) => updateTrainingTags(v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!pet.active}
							renderTags={(selected) =>
								selected.map((value) => (
									<DeletableChip
										key={value._id}
										label={value.name}
										{...{ onDelete: pet.active ? () => removeTag(value) : null }}
									/>
								))
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option.name} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField {...params} variant="filled" fullWidth label="Training Tags" />
							)}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<DebouncedTextField
							id="training-notes"
							variant="filled"
							multiline
							label="Internal Notes"
							fullWidth
							value={pet.training_notes}
							disabled={!pet.active}
							onChange={(e) => updatePet('training_notes', e.target.value)}
						/>
					</div>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default PetTrainingCard
